import {
  DISMISS_ALERT
} from './action-types';


export function dismissAlert() {
  return {
    type: DISMISS_ALERT
  };
}



// WEBPACK FOOTER //
// ./src/core/alerts/actions.js